var BANK_MATCH_OBJECT_SOURCE = require('../constants/bank-match-object-source')

function toTypeToken(value) {
    var withoutId = value.indexOf(':') !== -1 ? value.split(':')[0] : value
    var segments = withoutId.split('\\')

    return segments[segments.length - 1] || withoutId
}

function toObjectSource(type) {
    var token = toTypeToken(type)

    if (token === 'bill' || token === 'Bill' || token === 'AbstractBill') {
        return BANK_MATCH_OBJECT_SOURCE.BILL
    }

    if (
        token === 'invoice' ||
        token === 'Invoice' ||
        token === 'externalInvoice' ||
        token === 'ExternalInvoice' ||
        token === 'AbstractInvoice' ||
        token === 'creditNote' ||
        token === 'CreditNote'
    ) {
        return BANK_MATCH_OBJECT_SOURCE.INVOICE
    }

    return BANK_MATCH_OBJECT_SOURCE.LEDGER_ENTRY
}

function getSubjectType(subject) {
    if (!subject) {
        return null
    }

    if (typeof subject === 'string') {
        return subject
    }

    // Prefer BD reference ("invoice:id" / "bill:id") so credit notes still map to invoice/bill.
    // attributes.type is "creditNote" for both, which is not enough on its own.
    if (typeof subject.get === 'function') {
        return subject.get('reference') || subject.get('type')
    }

    return subject._data && subject._data.attributes && subject._data.attributes.type
}

module.exports = function getBankMatchObjectSource(types) {
    var subjectTypes = (types || []).map(getSubjectType).filter(Boolean)

    if (subjectTypes.length === 0) {
        return undefined
    }

    if (subjectTypes.length > 1) {
        return BANK_MATCH_OBJECT_SOURCE.MULTI_OBJECTS
    }

    return toObjectSource(subjectTypes[0])
}
